import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { IAddNewContactTileProps } from './models'

import styles from './AddNewContactTile.module.scss'

export const AddNewContactTile: FC<IAddNewContactTileProps> = ({ onAddNewContactClick }) => (
  <div className={styles['add-contact-wrap']}>
    <div className={styles['add-contact-wrap__card']}>
      <div className={styles.card} onClick={onAddNewContactClick} tabIndex={0}>
        <span className={styles.card__text}>
          <Translation text="partner-contacts_add-new" span />
        </span>
      </div>
    </div>
  </div>
)
